import debounce from 'lodash/debounce';
import { useMemo, useState } from 'react';

export const useOnRefresh = <T,>(
  refetch: () => Promise<T> | void
): { onDebouncedRefreshing: () => void; refreshing: boolean } => {
  const [refreshing, setRefreshing] = useState(false);

  const debounced = useMemo(
    () =>
      debounce(async () => {
        await refetch();
        setRefreshing(false);
      }, 300),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const onDebouncedRefreshing = () => {
    setRefreshing(true);
    debounced();
  };

  return {
    onDebouncedRefreshing,
    refreshing
  };
};
